export default __webpack_public_path__ + "static/media/GB-WLS.64c8f990.svg";